import { PageNavigationItem } from '../../../components/Navigation/PageNavigation/PageNavigation';

export const SUB_LINK_IDS = {
  MAP: 'fw-map',
  GENERAL_INFO: 'fw-generalInfo',
  TOP_SPECIES: 'fw-topSpecies',
  FISHING_REPORTS: 'fw-fishingReports',
  FISHING_REGULATIONS: 'fw-regulations',
  SPECIES: 'species',
  TOP_BAITS: 'top-baits',
  LOCAL_GUIDE: 'localGuide',
  REVIEWS: 'fw-reviews',
  NEARBY_WATERS: 'nearby-waters-section',
  SUGGEST_CHANGES: 'suggest-changes-section',
  EXPLORE_MORE: 'explore-more-section',
};

export function getSubNavLinks({
  hasSpecies,
  hasCatches,
  hasReviews,
  hasRegulations,
  hasNearbyWaters,
}: {
  hasSpecies: boolean;
  hasCatches: boolean;
  hasReviews: boolean;
  hasRegulations: boolean;
  hasNearbyWaters: boolean;
}): PageNavigationItem[] {
  return [
    { id: SUB_LINK_IDS.MAP, label: 'Map', orderMobile: 1, orderTablet: 1 },
    ...(hasSpecies
      ? [{ id: SUB_LINK_IDS.TOP_SPECIES, label: 'Top species', orderMobile: 2, orderTablet: 3 }]
      : []),
    ...(hasCatches
      ? [
          {
            id: SUB_LINK_IDS.FISHING_REPORTS,
            label: 'Fishing reports',
            orderMobile: 3,
            orderTablet: 4,
          },
        ]
      : []),
    { id: SUB_LINK_IDS.GENERAL_INFO, label: 'General info', orderMobile: 4, orderTablet: 2 },
    ...(hasRegulations
      ? [
          {
            id: SUB_LINK_IDS.FISHING_REGULATIONS,
            label: 'Regulations',
            orderMobile: 5,
            orderTablet: 5,
          },
        ]
      : []),
    ...(hasReviews
      ? [{ id: SUB_LINK_IDS.REVIEWS, label: 'Reviews', orderMobile: 6, orderTablet: 6 }]
      : []),
    ...(hasNearbyWaters
      ? [{ id: SUB_LINK_IDS.NEARBY_WATERS, label: 'Nearby waters', orderMobile: 7, orderTablet: 7 }]
      : []),
    { id: SUB_LINK_IDS.SUGGEST_CHANGES, label: 'Suggest changes', orderMobile: 8, orderTablet: 8 },
    { id: SUB_LINK_IDS.EXPLORE_MORE, label: 'Explore more', orderMobile: 9, orderTablet: 9 },
  ];
}
